import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/colors.css'; // Import the CSS variables
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Removed StrictMode which causes functions to run twice in development
root.render(
  <App />
);